import app from 'flarum/forum/app';
import Component from 'flarum/common/Component';
import ItemList from 'flarum/common/utils/ItemList';
import listItems from 'flarum/common/helpers/listItems';
import Link from 'flarum/common/components/Link';

export default class CustomNavbar extends Component {
  oninit(vnode) {}
  view() {
    return (
      <div class="container">
        <ul>{listItems(this.items().toArray())}</ul>
      </div>
    );
  }

  childActive(childTags) {
    var active = false;

    if (!childTags) {
      return active;
    }

    childTags.forEach((childTag) => {
      if (window.location.href.indexOf(app.route.tag(childTag)) !== -1) {
        active = true
      }
    })

    return active;
  }

  items() {
    const items = new ItemList();
    app.store
      .all('tags')
      .filter((singleMainTag) => !singleMainTag.data.attributes.isChild)
      .sort((a, b) => a.data.attributes.position - b.data.attributes.position) // Sortieren nach Position
      .map((tag) => {
        const active = window.location.href.indexOf(app.route.tag(tag)) !== -1 || this.childActive(tag.children())
        items.add(
          tag.data.attributes.slug,
          <li className={active ? 'active' : ''}>
            <Link className={active ? 'active' : ''} href={app.route.tag(tag)}>{tag.name()}</Link>
          </li>,
          0
        );
      });

    return items;
  }
}
